import api from "./api";

/** Chunked upload → object storage. Resolves with the completed upload record ({ upload_id, storage_path, kind, size, … }). */
export async function uploadFileChunked(file, { purpose = "MEDIA", caseId = null, onProgress, signal } = {}) {
  const init = await api.post("/ujms/uploads/init", { filename: file.name, content_type: file.type || "", size: file.size, purpose, case_id: caseId }, { signal });
  const { upload_id: id, chunk_size: cs, total_chunks: total } = init.data;
  let sent = 0;
  for (let i = 0; i < total; i += 1) {
    const blob = file.slice(i * cs, Math.min(file.size, (i + 1) * cs));
    let attempt = 0;
    for (;;) {
      try {
        await api.put(`/ujms/uploads/${id}/chunks/${i}`, blob, {
          signal, headers: { "Content-Type": "application/octet-stream" },
          onUploadProgress: (e) => onProgress?.(Math.min(0.99, (sent + (e.loaded || 0)) / file.size), { chunk: i + 1, total }),
        });
        break;
      } catch (e) {
        if (signal?.aborted || attempt >= 2 || (e.response && e.response.status < 500 && e.response.status !== 0)) throw e;
        attempt += 1;
        await new Promise((r) => setTimeout(r, 800 * attempt));
      }
    }
    sent += blob.size;
    onProgress?.(Math.min(0.99, sent / file.size), { chunk: i + 1, total });
  }
  const done = await api.post(`/ujms/uploads/${id}/complete`, {}, { signal });
  onProgress?.(1, { chunk: total, total });
  return { ...done.data, upload_id: id };
}

export const humanSize = (n = 0) => {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
};

export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;
